.sectionWrap {
	background-size: 100%;
}
.sectionInnerLeft {
	background: linear-gradient(to bottom, rgba(0, 95, 240, 0) 0, rgba(0, 95, 240, 0) 37.5%, #005ff0 47.5%, #005ff0 100%);
}
.sectionInnerRight {
	background: linear-gradient(to bottom, rgba(0, 95, 240, 0) 0, rgba(0, 95, 240, 0) 37.5%, #005ff0 47.5%, #005ff0 100%);
}
.contentWrapLeft {
	background: url("/images/home/pillar-texture-desktop-blue--left.png") no-repeat bottom center;
	background-size: cover;
	background-position: 0 90px;
	padding: 0 0 10.5% 0;
}
.contentWrapRight {
	background: url("/images/home/pillar-texture-desktop-blue--right.png") no-repeat bottom center;
	background-size: cover;
	background-position: 0 90px;
	padding: 0 0 10.5% 0;
}
.sectionTitle {
	font-size: 12.25vw;
}
.sectionCopy {
	font-family: "Bourgeois W00 Medium", sans-serif;
	text-transform: normal;
	font-weight: 700;
	margin-bottom: 0;
	font-size: 6vw;
	line-height: 1.35;
	background: #fce79c;
	background: linear-gradient(to bottom, #fce79c 0, #fa9323 100%);
	margin-bottom: 5%;
	padding: 5%;
	filter: drop-shadow(4px 4px 0 black);
	transform: rotate(358deg);
	border: 2px solid #000;
	color: #000;
}

@media screen and (min-width: 768px) {
	.sectionWrap {
		background-size: 100%;
	}
	.sectionInnerLeft {
		background: linear-gradient(
			to bottom,
			rgba(0, 95, 240, 0) 0,
			rgba(0, 95, 240, 0) 52.5%,
			#005ff0 62.5%,
			#005ff0 100%
		);
	}
	.sectionInnerRight {
		background: linear-gradient(
			to bottom,
			rgba(0, 95, 240, 0) 0,
			rgba(0, 95, 240, 0) 52.5%,
			#005ff0 62.5%,
			#005ff0 100%
		);
	}
	.contentWrapLeft {
		padding: 0;
	}
	.contentWrapRight {
		padding: 0;
	}
	.sectionTitle {
		font-size: 9vw;
		line-height: 1;
	}

	.sectionCopy {
		font-size: 3.15vw;
		line-height: 1.35;
	}
}

@media screen and (min-width: 1024px) {
	.sectionInnerLeft {
		background: url("/images/home/pillar-texture-desktop-blue--left.png") no-repeat right center;
		background-size: cover;
	}
	.sectionInnerRight {
		background: url("/images/home/pillar-texture-desktop-blue--right.png") no-repeat right center;
		background-size: cover;
	}
	.contentWrapLeft {
		background: linear-gradient(to left, #005ff0 0, rgba(0, 95, 240, 0) 100%);
		max-width: 42.25vw;
		min-height: 44.95vw;
		margin-left: 57.75vw;
	}
	.contentWrapRight {
		background: linear-gradient(to right, #005ff0 0, rgba(0, 95, 240, 0) 100%);
		max-width: 42.25vw;
		min-height: 44.95vw;
		margin-left: 0;
	}
	.copyWrap {
		padding: 27.5% 0 0;
		max-width: 42.25vw;
		min-height: 44.95vw;
	}
	.sectionTitle {
		font-size: 4.25vw;
	}

	.sectionCopy {
		font-size: 1.75vw;
	}
}
